import Services from './Components/Categories/ServiceCategories'
import Reunions from './Components/Categories/ReunionCategories'
import update from 'immutability-helper'
import qs from 'qs'

const filterByApproval = ({
  state,
  varNames
}) => {
  const currentItems = filterPhotos({ state, varNames })

  if (state.isAdmin) {
    // console.log('Filter By Approval Photos State: ', state, currentItems)
  }

  const returnable = currentItems.filter((o) => {
    if (!!state.showApproved && !!o.isApproved) {
      return true
    }

    return !state.showApproved && !o.isApproved
  })

  if (state.isAdmin) {
    // console.log('Returnable: ', returnable)
  }

  return returnable
}

const filterPhotos = ({
  state,
  varNames
}) => {
  const {
    allImages,
    [`${varNames.academyTimeframe}`]: academyTimeframe,
    [`${varNames.category}`]: category,
    [`${varNames.classmates}`]: classmates,
    [`${varNames.companies}`]: companies,
    [`${varNames.decade}`]: decade,
    [`${varNames.service}`]: service,
    [`${varNames.serviceBranch}`]: serviceBranch,
    [`${varNames.subsection}`]: subsection,
    [`${varNames.year}`]: year
  } = state

  if (state.isAdmin) {
    /** console.log('Filter Photos State: ', state) */
  }

  return allImages.filter((o) => {
    if (classmates !== '') {
      if (
        classmates.split(',').map(
          (j) => o.users.split(',').includes(j)
        ).includes(false)
      ) {
        return false
      }
    }

    if (companies !== '') {
      if (
        companies.split(',').map(
          (j) => o.companies.split(',').includes(j)
        ).includes(false)
      ) {
        return false
      }
    }

    if (category !== '') {
      if (category !== o.category) {
        return false
      }

      if (
        category === 'Academy Years' &&
        academyTimeframe !== '' &&
        academyTimeframe !== o.decadeTimeframe
      ) {
        return false
      }

      if (category === 'In Uniform') {
        if (decade !== '' && decade !== o.decadeTimeframe) {
          return false
        }
        if (service !== '') {
          if (service !== o.service) {
            return false
          }

          if ((Services.includes(service)) &&
            serviceBranch !== '' && serviceBranch !== o.branchSubsection
          ) {
            return false
          }
        }
      }

      if (category === 'Post Military Life') {
        if (decade !== '' && decade !== o.decadeTimeframe) {
          return false
        }
        if (year !== '' && year !== o.year) {
          return false
        }
      }

      if (
        Reunions.map((value) => {
          return !(
            category === value &&
            subsection !== '' &&
            subsection !== o.branchSubsection
          )
        }).includes(false)
      ) {
        return false
      }
    }

    return true
  })
}

const filterNewApprovalPhotos = ({ state, setState, varNames }) => {
  const newPhotos = filterByApproval({
    state,
    varNames
  })

  if (state.isAdmin) {
    /** console.log('Filter New Approval Photos State: ', state) */
  }

  setState(update(state, {
    items: { $set: newPhotos },
    lastPage: { $set: Math.ceil(newPhotos.length / 60) },
    page: { $set: 1 }
  }))
  const queryString = handlePhotosQS({ state, varNames, inAdmin: true })

  window.location.hash = qs.stringify(queryString)
}

const filterNewGalleryPhotos = ({ state, setState, varNames }) => {
  const newPhotos = filterPhotos({
    state,
    varNames
  })

  if (state.isAdmin) {
    /** console.log('Filter New Gallery Photos State: ', state) */
  }

  setState(update(state, {
    items: { $set: newPhotos },
    lastPage: { $set: Math.ceil(newPhotos.length / 60) },
    page: { $set: 1 }
  }))
  const queryString = handlePhotosQS({ state, varNames })

  if (state[`${varNames.category}`] !== '') {
    const location = state[`${varNames.category}`].split(' ').join('-').toLowerCase()
    window.history.pushState(
      '',
      'Photos: ' + state[`${varNames.category}`],
      '/photo-gallery/' + location + '/'
    )
  } else {
    window.history.pushState('', 'Photos', '/photo-gallery/')
  }

  window.location.hash = qs.stringify(queryString)
}

const getMultiObjectFromValue = (value, collection) => {
  if (value === null) {
    return null
  }
  if (value.includes(',')) {
    value = value.split(',')
  } else {
    value = [value]
  }

  return collection.filter(item => value.includes(item.value + ''))
}

const getMultiValueFromObject = (object) => {
  if (object === null) {
    return null
  }

  return object.map(v => v.value).join(',')
}

const getObjectFromValue = (value, collection) => getMultiObjectFromValue(value, collection)[0]

const getValueFromObject = (object) => {
  if (object === null) {
    return ''
  }

  return object.value
}

const handleErrorResponse = ({ className, error, message, setState, state, type = '' }) => {
  setState(update(state, {
    notices: {
      $set: [
        ...state.notices,
        ...[{
          message: message + error,
          type
        }]
      ]
    },
    buttonClass: { $set: className }
  }))
}

const handlePhotosQS = ({ state, varNames, inAdmin = false }) => {
  const queryString = {}

  if (state[`${varNames.academyTimeframe}`] !== '') {
    queryString.academyTimeframe = state[`${varNames.academyTimeframe}`]
  }
  if (state[`${varNames.classmates}`] !== '') {
    queryString.classmates = state[`${varNames.classmates}`]
  }
  if (state[`${varNames.companies}`] !== '') {
    queryString.companies = state[`${varNames.companies}`]
  }
  if (state[`${varNames.decade}`] !== '') {
    queryString.decade = state[`${varNames.decade}`]
  }
  if (state[`${varNames.service}`] !== '') {
    queryString.service = state[`${varNames.service}`]
  }
  if (state[`${varNames.serviceBranch}`] !== '') {
    queryString.serviceBranch = state[`${varNames.serviceBranch}`]
  }
  if (state[`${varNames.subsection}`] !== '') {
    queryString.subsection = state[`${varNames.subsection}`]
  }
  if (state[`${varNames.year}`] !== '') {
    queryString.year = state[`${varNames.year}`]
  }
  if (inAdmin) {
    queryString.page = state.page
    queryString.showAdmin = state.showAdmin
  }

  return queryString
}

export {
  filterByApproval,
  filterNewApprovalPhotos,
  filterNewGalleryPhotos,
  filterPhotos,
  getMultiObjectFromValue,
  getMultiValueFromObject,
  getObjectFromValue,
  getValueFromObject,
  handleErrorResponse,
  handlePhotosQS
}
